export enum TransactionAction {
    Redeem = "REDEEM",
    Earn = "EARN",
}